type Mixpanel = typeof import('mixpanel-browser').default;

let mixpanelModule: Promise<Mixpanel> | undefined;

const loadMixpanel = (): Promise<Mixpanel> => {
  mixpanelModule ??= import('mixpanel-browser').then((module) => module.default);
  return mixpanelModule;
};

export const withMixpanel = (context: string, use: (mixpanel: Mixpanel) => void): void => {
  loadMixpanel()
    .then(use)
    .catch((error) => console.warn(`[Analytics] ${context} failed:`, error));
};
